import * as React from 'react'
import { TextField } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs, { Dayjs } from 'dayjs'

export interface DatePickerFieldProps {
  label: string
  value: Dayjs | string | null
  onChange: (value: string | null) => void
  disabled?: boolean
  required?: boolean
  inputFormat?: string
}

const toDayjs = (value: Dayjs | string | null): Dayjs | null => {
  if (value === null || value === undefined) return null
  if (typeof value === 'string') {
    const parsed = dayjs(value)
    return parsed.isValid() ? parsed : null
  }
  return value
}

export default function DatePickerField({
  label,
  value,
  onChange,
  disabled = false,
  required = false,
  inputFormat = 'DD.MM.YYYY'
}: DatePickerFieldProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        disabled={disabled}
        inputFormat={inputFormat}
        value={toDayjs(value)}
        onChange={(newValue) => {
          onChange(newValue?.isValid() ? newValue.format('YYYY-MM-DD') : null)
        }}
        renderInput={(params) => (
          <TextField fullWidth required={required} {...params} />
        )}
      />
    </LocalizationProvider>
  )
}
